import { ISingleEpletMmRisk } from './single-eplet-mm-risk'

export interface IAdpRecipientFromChain {
    chainId: number,
    clusterNumber: number,
    donorPosition: number,
    donorCenterAlias: string
    donorAlias: string,
    recipientCenterAlias: string,
    recipientAlias: string,
    donorBloodType: string,
    donorA1: number,
    donorAb1: number,
    recipientBloodType: string,
    donorAge: number,
    recipientAge: number,
    cpra4: number,
    wait: number,
    txpDate: string,
    mps: number,
    isAdpChip: boolean,
    pdclChainId: number,
    epletMm: ISingleEpletMmRisk,
    bmtMm: number
}